module.exports = __webpack_public_path__ + "static/media/HOME-image-map.d3ed909e.png";